"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MosaicMetadataTransactionBuilder = void 0;

var GeneratorUtils_1 = require("./GeneratorUtils");

var MosaicMetadataTransactionBodyBuilder_1 = require("./MosaicMetadataTransactionBodyBuilder");

var TransactionBuilder_1 = require("./TransactionBuilder");

var MosaicMetadataTransactionBuilder = /*#__PURE__*/function (_TransactionBuilder_) {
  _inherits(MosaicMetadataTransactionBuilder, _TransactionBuilder_);

  var _super = _createSuper(MosaicMetadataTransactionBuilder);

  function MosaicMetadataTransactionBuilder(signature, signerPublicKey, version, network, type, fee, deadline, targetAddress, scopedMetadataKey, targetMosaicId, valueSizeDelta, value) {
    var _this;

    _classCallCheck(this, MosaicMetadataTransactionBuilder);

    _this = _super.call(this, signature, signerPublicKey, version, network, type, fee, deadline);
    _this.mosaicMetadataTransactionBody = new MosaicMetadataTransactionBodyBuilder_1.MosaicMetadataTransactionBodyBuilder(targetAddress, scopedMetadataKey, targetMosaicId, valueSizeDelta, value);
    return _this;
  }

  _createClass(MosaicMetadataTransactionBuilder, [{
    key: "getTargetAddress",
    value: function getTargetAddress() {
      return this.mosaicMetadataTransactionBody.getTargetAddress();
    }
  }, {
    key: "getScopedMetadataKey",
    value: function getScopedMetadataKey() {
      return this.mosaicMetadataTransactionBody.getScopedMetadataKey();
    }
  }, {
    key: "getTargetMosaicId",
    value: function getTargetMosaicId() {
      return this.mosaicMetadataTransactionBody.getTargetMosaicId();
    }
  }, {
    key: "getValueSizeDelta",
    value: function getValueSizeDelta() {
      return this.mosaicMetadataTransactionBody.getValueSizeDelta();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.mosaicMetadataTransactionBody.getValue();
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var size = _get(_getPrototypeOf(MosaicMetadataTransactionBuilder.prototype), "getSize", this).call(this);

      size += this.mosaicMetadataTransactionBody.getSize();
      return size;
    }
  }, {
    key: "getBody",
    value: function getBody() {
      return this.mosaicMetadataTransactionBody;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var newArray = Uint8Array.from([]);

      var superBytes = _get(_getPrototypeOf(MosaicMetadataTransactionBuilder.prototype), "serialize", this).call(this);

      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, superBytes);
      var mosaicMetadataTransactionBodyBytes = this.mosaicMetadataTransactionBody.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, mosaicMetadataTransactionBodyBytes);
      return newArray;
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var byteArray = Array.from(payload);
      var superObject = TransactionBuilder_1.TransactionBuilder.loadFromBinary(payload);
      byteArray.splice(0, superObject.getSize());
      var mosaicMetadataTransactionBody = MosaicMetadataTransactionBodyBuilder_1.MosaicMetadataTransactionBodyBuilder.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, mosaicMetadataTransactionBody.getSize());
      return new MosaicMetadataTransactionBuilder(superObject.signature, superObject.signerPublicKey, superObject.version, superObject.network, superObject.type, superObject.fee, superObject.deadline, mosaicMetadataTransactionBody.targetAddress, mosaicMetadataTransactionBody.scopedMetadataKey, mosaicMetadataTransactionBody.targetMosaicId, mosaicMetadataTransactionBody.valueSizeDelta, mosaicMetadataTransactionBody.value);
    }
  }, {
    key: "createMosaicMetadataTransactionBuilder",
    value: function createMosaicMetadataTransactionBuilder(signature, signerPublicKey, version, network, type, fee, deadline, targetAddress, scopedMetadataKey, targetMosaicId, valueSizeDelta, value) {
      return new MosaicMetadataTransactionBuilder(signature, signerPublicKey, version, network, type, fee, deadline, targetAddress, scopedMetadataKey, targetMosaicId, valueSizeDelta, value);
    }
  }]);

  return MosaicMetadataTransactionBuilder;
}(TransactionBuilder_1.TransactionBuilder);

exports.MosaicMetadataTransactionBuilder = MosaicMetadataTransactionBuilder;